<template>
	<div class="login-center-wrap">
		<div id="loginCenterRight">
			<div class="login-form">
				<span class="login-name bold">비밀번호 찾기</span>
				<!-- <div class="login-mode">
					<button type="button" :class="isMode == 1 ? 'mode' : ''" @click="selectMode(1)">모니터링 담당자</button>
					<button type="button" :class="isMode == 2 ? 'mode' : ''" @click="selectMode(2)">코디네이터</button>
				</div> -->
				<!-- <div>
					<p class="account-title">Find ID</p>
					<input
						type="text"
						class="input-login-style sha-focus-666 bmargin-15"
						placeholder="Please enter yout email."
						v-model="item.findIdEmail"
						style="width:calc(70% - 20px); margin: 0 20px 0 0;"
						@keyup="idValidating()"
					/>
					<button type="button" class="button-blue" style="width: 25%;" @click="findId()">Find ID</button>
					<p class="txt-validation" v-if="!idValidate">
						* Email is required
					</p>
				</div> -->
				<input
					type="text"
					class="input-login-style sha-focus-666 bmargin-15"
					placeholder="가입하신 이메일을 입력해주십시오."
					v-model="item.findPsEmail"
					style="margin-top: 2.2vh"
					@keyup="psValidating()"
				/>
				<input
					type="text"
					class="input-login-style sha-focus-666 bmargin-15"
					placeholder="아이디를 입력해주십시오."
					v-model="item.findPsId"
					style="margin-top: 1vh;"
					@keyup="psValidating()"
				/>
				<button type="button" class="login-button" @click="findPs()">
					비밀번호 찾기
				</button>
				<div class="login-sub">
					<button type="button" @click="findUser(1)">아이디 찾기</button>
					<div>|</div>
					<button type="button" @click="doCancel()">로그인</button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "FindAccountPassword",
	created() {
		this.logger.debug(this, "created()");
	},
	data() {
		return {
			item: {},
			idValidate: true,
			psValidate: true,
			isMode: 1,
		};
	},
	methods: {
		selectMode(code){
			if(code == 1){ this.isMode = 1;}
			else{this.isMode = 2;}
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$router.push(this.config.contextRoot + "/login");
		},
		psValidating() {
			if(this.item.findPsEmail && this.item.findPsId) this.psValidate = true;
		},
		findPs() {
			this.logger.debug(this, "findPs()");

			if(!this.item.findPsEmail)
			{
				this.psValidate = false;
				return ;
			}
			else
			{
				this.$set(this.item, "emailAddress", this.item.findPsEmail);
			}

			if(!this.item.findPsId){
				this.psValidate = false;
				return ;
			}
			else
			{
				this.$set(this.item, "userId", this.item.findPsId);
			}
			
			axios
				.post(this.config.contextRoot + "/login/findPassword.do", this.item)
				.then((response) => {
					console.log(response);
					this.$alert("이메일이 전송되었습니다.", "Success", "success");
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
					this.$alert("Error.", "Warn","warning");
				});
		},
		findUser(code) {
			this.logger.debug(this, ".findUser()");
			if(code == 1){
				this.$router.push(this.config.contextRoot + "/login/find/account/id");
			}
			else{
				this.$router.push(this.config.contextRoot + "/login/find/account/password");
			}
		},
	},
};
</script>
